var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.initialized && _vm.user
    ? _c(
        "div",
        { attrs: { id: "user-profile-wrapper" } },
        [
          _c("ci-user-profile", {
            key: _vm.$route.path,
            attrs: { user: _vm.user },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }